import React, { useEffect, useState } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import LoadingScreen from '../../LoadingScreen';
import axios from 'axios';


const BarChart = ({salesByCat}) => {
    const [loading,setLoading] = useState(false);


const generateWholeNumbersYAxis = (data) => {
  const maxTicketSales = Math.max(...data.map((d) => d.ticketSales));
  return Array.from({ length: maxTicketSales + 1 }, (_, index) => index);
};


  return (
    <div >
      {loading ? <LoadingScreen /> : 
       <div style={{ height: '25vh', width:"100%" }}>
        <h4 style={{marginTop:"-1em"}}>Sales by Event Category</h4>
         <ResponsiveBar
        data={salesByCat}
        keys={['ticketSales']}
        indexBy="category"
        margin={{ top: 20, right: 105, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={["#6563FF"]}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Event Category',
          legendPosition: 'middle',
          legendOffset: 42,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Ticket Sales',
          legendPosition: 'middle',
          legendOffset: -40,
          tickValues: generateWholeNumbersYAxis(salesByCat),
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor="white"
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={(e) =>
          e.id + ': ' + e.formattedValue + ' in Event Category: ' + e.indexValue
        }
      />
    </div>
}
</div>
  );
};

export default BarChart;
